export const B2B_OUTCOME_OPTIONS = [
    { value: "new", label: "New", badgeClass: "bg-blue-100 text-blue-700 border-blue-200" },
    { value: "follow_up", label: "Follow Up", badgeClass: "bg-amber-100 text-amber-700 border-amber-200" },
    { value: "quotation_sent", label: "Quotation Sent", badgeClass: "bg-indigo-100 text-indigo-700 border-indigo-200" },
    { value: "negotiation", label: "Negotiation", badgeClass: "bg-purple-100 text-purple-700 border-purple-200" },
    { value: "sample_requested", label: "Sample Requested", badgeClass: "bg-teal-100 text-teal-700 border-teal-200" },
    { value: "npc", label: "NPC", badgeClass: "bg-gray-100 text-gray-700 border-gray-200" },
    { value: "not_interested", label: "Not Interested", badgeClass: "bg-rose-100 text-rose-700 border-rose-200" },
    { value: "blocked", label: "Blocked", badgeClass: "bg-slate-800 text-white border-slate-800" },
];

export const B2B_LOG_OUTCOME_OPTIONS = B2B_OUTCOME_OPTIONS.filter(option => option.value !== "new");

export const B2B_INTERACTION_TYPE_OPTIONS = [
    { value: "call", label: "Call" },
    { value: "visit", label: "Field Visit" },
    { value: "whatsapp", label: "WhatsApp" },
];

export const B2B_PURPOSE_OPTIONS = [
    { value: "call", label: "Call" },
    { value: "visit", label: "Visit" },
    { value: "quotation", label: "Quotation" },
    { value: "payment", label: "Payment" },
    { value: "reorder", label: "Reorder" },
    { value: "other", label: "Other" },
];

export const B2B_OUTCOME_MAP = B2B_OUTCOME_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item;
    return acc;
}, {});

export const B2B_PURPOSE_MAP = B2B_PURPOSE_OPTIONS.reduce((acc, item) => {
    acc[item.value] = item;
    return acc;
}, {});
